export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_REQUEST_2FA = 'AUTH_REQUEST_2FA'
export const AUTH_REQUEST_2FA_RENEW = 'AUTH_REQUEST_2FA_RENEW'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_REFRESH = 'AUTH_REFRESH'
export const CHECK_TOKEN = 'CHECK_TOKEN'



// WEBPACK FOOTER //
// ./src/store/actions/auth.js